import { useMemo, useState } from "react";
import { Button, Checkbox, Drawer, Segmented, Select, Space, Typography, message } from "antd";

const { Text } = Typography;

const DAY_OPTIONS = [
  { label: "Lun", value: "mon" },
  { label: "Mar", value: "tue" },
  { label: "Mer", value: "wed" },
  { label: "Jeu", value: "thu" },
  { label: "Ven", value: "fri" },
  { label: "Sam", value: "sat" },
  { label: "Dim", value: "sun" },
];

export default function FrequencyDrawer({ open, onCancel, onConfirm }) {
  const [mode, setMode] = useState("free"); // 'free' | 'custom'
  const [amount, setAmount] = useState(3);  // 1..9
  const [unit, setUnit] = useState("per_week"); // 'per_day' | 'per_week'
  const [days, setDays] = useState(["mon", "wed", "fri"]);

  const valid = useMemo(() => {
    if (mode === "free") return amount >= 1 && amount <= 9;
    return days.length > 0;
  }, [mode, amount, days]);

  function handleOk() {
    if (!valid) {
      return message.warning("Sélection de fréquence invalide.");
    }
    const freq =
      mode === "free"
        ? { kind: "free", amount, unit }
        : { kind: "custom", days };
    onConfirm?.(freq);
  }

  return (
    <Drawer
      title="Configurer la fréquence"
      open={open}
      onClose={onCancel}
      width={420}
      extra={
        <Space>
          <Button onClick={onCancel}>Annuler</Button>
          <Button type="primary" onClick={handleOk}>
            Ajouter
          </Button>
        </Space>
      }
    >
      <Space direction="vertical" size={16} style={{ width: "100%" }}>
        <Segmented
          value={mode}
          onChange={setMode}
          options={[
            { label: "Fréquence libre", value: "free" },
            { label: "Fréquence personnalisée", value: "custom" },
          ]}
        />

        {mode === "free" ? (
          <Space direction="vertical" size={12} style={{ width: "100%" }}>
            <div>
              <Text type="secondary">Nombre</Text>
              <Select
                value={amount}
                onChange={setAmount}
                style={{ width: 160 }}
                options={Array.from({ length: 9 }, (_, i) => i + 1).map((n) => ({
                  label: n,
                  value: n,
                }))}
              />
            </div>
            <div>
              <Text type="secondary">Unité</Text>
              <Segmented
                value={unit}
                onChange={setUnit}
                options={[
                  { label: "/ jour", value: "per_day" },
                  { label: "/ semaine", value: "per_week" },
                ]}
              />
            </div>
          </Space>
        ) : (
          <Space direction="vertical" size={12} style={{ width: "100%" }}>
            <Text type="secondary">Jours</Text>
            <Checkbox.Group
              options={DAY_OPTIONS}
              value={days}
              onChange={setDays}
            />
          </Space>
        )}
      </Space>
    </Drawer>
  );
}
